import { Button } from "@/components/ui/button";
import { Image } from "@/components/ui/image";
import { LOGIN_URL } from "@/lib/static";
import { removeToken } from "@/lib/token";
import { Link, useNavigate } from "react-router-dom";

export const NotAuthorizedTemplateV2 = () => {
  const navigate = useNavigate();
  const handleLogout = () => {
    removeToken();
    navigate(LOGIN_URL);
  };
  return (
    <div className="flex items-center h-full relative w-full">
      <div className="flex items-center h-full relative w-full justify-center flex-col">
        <Image
          src="/images/error-401.svg"
          alt=""
          className="h-[400px] mix-blend-multiply"
        />
        <h1 className="pt-4 text-xl font-semibold text-slate-800 dark:text-navy-50">
          You are not authorized to access any module
        </h1>
        <div className="py-2 mb-5 text-slate-500 dark:text-navy-200 text-center">
          It seems you don't have permission to access this page. <br />
          Please contact your administrator.
        </div>
        <Link to="/">
          <Button onClick={handleLogout}>Logout</Button>
        </Link>
      </div>
    </div>
  );
};
